// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input.form-control[data-v-e0b718fe]::-webkit-inner-spin-button,input.form-control[data-v-e0b718fe]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input.form-control[type=number][data-v-e0b718fe]{-moz-appearance:textfield}", ""]);
// Exports
module.exports = exports;
